import { setup } from 'xstate';

import { useMachine } from '@xstate/react';
import * as React from 'react';

// https://github.com/statelyai/xstate/discussions/2406#discussioncomment-1122999

function convertPixelToSvgCoord(event: MouseEvent, el = event.currentTarget as SVGGElement) {
  const svg = el.ownerSVGElement!;
  let p = svg.createSVGPoint();
  p.x = event.clientX;
  p.y = event.clientY;
  p = p.matrixTransform(svg.getScreenCTM()?.inverse());
  return p;
}

// https://www.redblobgames.com/making-of/draggable/#mouse-events
const machine = setup({
  types: {} as {
    context: {
      el?: SVGGElement;
    };
    events:
      | {
          type: 'mousedown';
          event: MouseEvent;
          el: SVGGElement;
        }
      | {
          type: 'mouseup';
          event: MouseEvent;
        }
      | {
          type: 'mousemove';
          event: MouseEvent;
        };
  },
  actions: {},
}).createMachine({
  id: 'Mouse events only',
  initial: 'not_dragging',
  states: {
    not_dragging: {
      on: {
        mousedown: {
          target: 'dragging',
          actions: [
            ({ context, event: { el } }) => {
              context.el = el;
            },
          ],
        },
      },
    },
    dragging: {
      on: {
        mousemove: {
          actions: [
            ({ context: { el }, event: { event } }) => {
              if (el) {
                // console.log('mousedown', { event });
                const { x, y } = convertPixelToSvgCoord(event, el);
                el.setAttribute('transform', `translate(${x}, ${y})`);
              }
            },
          ],
        },
        mouseup: {
          target: 'not_dragging',
          actions: [
            ({ context }) => {
              context.el = undefined;
            },
          ],
        },
      },
    },
  },
});

function DocumentEvents() {
  const [state, send] = useMachine(machine);
  const refG = React.useRef<SVGGElement>(null);
  React.useEffect(() => {
    const el = refG.current!;
    function mousedown(event: MouseEvent) {
      send({ type: 'mousedown', event, el });
    }
    function mouseup(event: MouseEvent) {
      send({ type: 'mouseup', event });
    }
    function mousemove(event: MouseEvent) {
      send({ type: 'mousemove', event });
    }
    el.addEventListener('mousedown', mousedown);
    document.addEventListener('mouseup', mouseup);
    document.addEventListener('mousemove', mousemove);
    return () => {
      el.removeEventListener('mousedown', mousedown);
      document.removeEventListener('mouseup', mouseup);
      document.removeEventListener('mousemove', mousemove);
    };
  }, []);
  // console.log('MouseOnlyXState', { state });
  return (
    <div className="container rounded border border-current relative" style={{ height: '300px' }}>
      <div className="absolute" style={{ left: '50%', transform: 'translateX(-50%)' }}>
        <div className="backdrop-brightness-90 p-1 rounded-md">{state.value}</div>
      </div>
      <svg viewBox="0 0 300 100">
        <g ref={refG} className="cursor-grab" transform="translate(30, 30)">
          <circle cx={0} cy={0} stroke="black" r="30"></circle>
          <g fontSize="14" textAnchor="middle" fill="white">
            <text dy="0.0em">Drag</text>
            <text dy="1.0em">me</text>
          </g>
        </g>
      </svg>
    </div>
  );
}

export default React.memo(DocumentEvents);
